import _extends from "@babel/runtime/helpers/extends";
import React, { Component, useMemo } from 'react';
export var useErrorBoundary = WrappedComponent => useMemo(() => class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderError: null
    };
  }
  static getDerivedStateFromError(renderError) {
    return {
      renderError
    };
  }
  render() {
    var {
      props,
      state
    } = this;
    var {
      renderError
    } = state;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      renderError: renderError
    }));
  }
}, []);